import { DirectiveOptions } from 'vue';

const hidden: DirectiveOptions = {
    bind(el): void {
        // Do nothing
    },
};

export default hidden;



// WEBPACK FOOTER //
// ./src/directives/hidden.ts